import { UIText2, Tooltip, Wait16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './warning.css';

interface IActualProps {
  label: string;
  title: string;
  description: React.ReactNode;
}
export const Warning = ({ label, title, description }: IActualProps) => {
  return (
    <div className={styles['warning']}>
      <div className={styles['label']}>
        <div className={styles['warn']}>
          <Tooltip theme="white" header={title} placement="right" title={description}>
            <Wait16 color="error_100" />
          </Tooltip>
        </div>
        <UIText2 color="gray60_100">{label}</UIText2>
      </div>
    </div>
  );
};

Warning.displayName = 'Warning';
